import './modal-request-quotas.scss';

//react
import { useState, useRef, useEffect } from 'react';
import { useMutation } from '@apollo/client';
//shared
import Modal from '../modal-alert/modal-alert';
import { CREATE_REQUEST_QUOTAS } from '../../graphql/branch';
import Message from '../message/message';
import { MESSAGE_ADD_QUOTAS } from '../../../class-branch/constants/messages';
//material
import { Box, Button, FilledInput, InputAdornment } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import Icon from '../icon/icon';

export const ModalRequestQuotas = ({ calendarId, availableSpace, isRequestQuota }: { calendarId: number, availableSpace: number, isRequestQuota: any }) => {

  let [estatusModal, changeStateModal] = useState(false);
  let [estatusSubModal, changeStateSubModal] = useState(false);
  let [availableSpacesTextValue, setAvailableSpacesTextValue] = useState<number>(availableSpace ?? 0);

  const onAvailableSpacesChange = (e: any) => {
    const newValue = parseInt(e.target.value);
    setAvailableSpacesTextValue(newValue);
  };

  const [RequestQuotas, { data, loading, error, reset }] = useMutation(CREATE_REQUEST_QUOTAS, {
    variables: {
      userId: null,
      calendarId: calendarId,
      newAvailableSpace: availableSpacesTextValue,
    },
    refetchQueries: [CREATE_REQUEST_QUOTAS]
  });
  let message = MESSAGE_ADD_QUOTAS;
  message.open = useRef<any>(null);

  if (data) {
    message.textMessage = data.createRequestQuota.message;
    message.style = data.createRequestQuota.success ? 'success' : 'danger';
    changeStateSubModal(!estatusSubModal);
    setTimeout(() => {
      message.open.current.show();
    }, 500);
    reset();
  }

  function changeAvailableSpaces(action: string) {

    let newAvailableSpacesTextValue: number =
      action === 'add' ? availableSpacesTextValue += 1 : availableSpacesTextValue -= 1;

    setAvailableSpacesTextValue(newAvailableSpacesTextValue);
  }

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (error) console.log(`Submission error! ${error.message}`);

  return (
    <div className="modal-request-quotas">

      <Button className={`btn-more-space ${windowWidth <= 860 ? ' btn-action-mobile' : ''}`} disabled={loading || isRequestQuota ? true : false} onClick={() => changeStateModal(!estatusModal)}>
        {windowWidth >= 861 && (<span>Solicitar más cupos</span>)}
        {windowWidth <= 860 && (<Icon width='20' height='19' name='multiple-add-user'></Icon>)}
      </Button>


      <Modal
        estatus={estatusModal}
        changeStatus={estatusModal}
        showHeader={false}
        buttonCancel={false}
        classNameModal='class-modal-request-quotas'
      >
        <div className='content'>
          <div className="content-body">
            <Icon name='person-dumbbell' width='80' height='80' color='#00195E' />
            <h3>¿Cuántos cupos quieres solicitar?</h3>
            <p className='text-body'>
              Atenderemos tu solicitud en el menor tiempo posible, tan pronto este lista te notificaremos o nos
              comunicaremos contigo si hay alguna novedad
            </p>

            <div className='container-space'>
              <Box>
                <Button className='btn-space'
                  disabled={loading || !availableSpacesTextValue ? true : false}
                  onClick={() => { changeAvailableSpaces('remove') }}>
                  <Remove fontSize="small" />
                </Button>
                <FilledInput
                  className='input-space' readOnly
                  value={availableSpacesTextValue ? availableSpacesTextValue : 0}
                  onChange={(ev) => onAvailableSpacesChange(ev)}
                  endAdornment={<InputAdornment position="end">Cupos</InputAdornment>}
                />
                <Button className='btn-space'
                  disabled={loading}
                  onClick={() => { changeAvailableSpaces('add') }}>
                  <Add fontSize="small" />
                </Button>
              </Box>
            </div>

            <div className="buttons">
              <Button className='ok-button' disabled={loading} onClick={() => {
                RequestQuotas({
                  variables: {
                    userId: null,
                    calendarId: calendarId,
                    newAvailableSpace: availableSpacesTextValue,
                  },
                });

                changeStateModal(false);
                changeStateSubModal(true);
              }}>
                Solicitar cupos
              </Button>

              <Button onClick={() => changeStateModal(!estatusModal)} className="cancel-button">No, mejor no</Button>
            </div>
          </div>
        </div>
      </Modal >

      <Modal estatus={estatusSubModal}
        changeStatus={estatusSubModal}
        showHeader={false}
        buttonCancel={false}>
        <Icon name='person' width='80' height='80' color='#00195E' />
        <h3>¡Listo!</h3>
        <p>Solicitud enviada</p>
      </Modal>

      <Message data={message} ref={message.open} />
    </div >
  )
}